import React, { useState } from 'react';
import { Share2, Copy, Check } from 'lucide-react';

const CompactExportButton = ({ product, category, currentCategory, formatReportPeriod, getLastUpdateDate, lastUpdated = null }) => {
  const [copyStatus, setCopyStatus] = useState('');

  // שימוש באותה לוגיקת יצירת הטקסט מהקומפוננט המקורי
  const generateExportText = () => {
    const stocksExp = product.exposures?.stocks || 0;
    const foreignExp = product.exposures?.foreign || 0;
    const currencyExp = product.exposures?.currency || 0;
    const domesticExp = foreignExp >= 100 ? 0 : Math.max(0, 100 - foreignExp);
    const illiquidAssets = product.performance?.liquidAssetsPercent ? 
      (100 - product.performance.liquidAssetsPercent) : 0;
    const riskData = product.riskLevel || { level: 0, name: 'לא ידוע' };

    const lines = [
      "📋 פרטי הקופה - יצוא מגמלנט AI",
      "",
      `📌 שם הקופה: ${product.name || 'לא זמין'}`,
      `🏢 גוף מנהל: ${product.company || 'לא זמין'}`,
      `📊 סוג מוצר: ${product.classification || currentCategory?.title || 'לא זמין'}`,
      `🎯 מסלול השקעה: ${product.specialization || product.fundInfo?.specialization || 'לא זמין'}`,
      `🔢 מספר באוצר: ${product.id || 'לא זמין'}`,
      "",
      "💰 נתונים כספיים:",
      `   גודל הקופה: ${product.totalAssets ? 
        `${new Intl.NumberFormat('he-IL').format(product.totalAssets / 1000000)} מיליוני ש"ח` 
        : 'לא זמין'}`,
      "",
      "📈 תשואות:",
      `   תאריך נכונות הנתונים: ${lastUpdated}`,
      `   תשואה חודש ${lastUpdated}: ${product.returns?.month1 ? `${product.returns.month1.toFixed(2)}%` : 'לא זמין'}`,
      `   תשואה מצטברת 12 חודשים אחרונים: ${product.returns?.year1 ? `${product.returns.year1.toFixed(2)}%` : 'לא זמין'}`,
      `   תשואה מצטברת 2 שנים אחרונות: ${product.returns?.year2 ? `${product.returns.year2.toFixed(2)}%` : 'לא זמין'}`,
      `   תשואה ממוצעת 2 שנים אחרונות: ${product.returns?.avgAnnual2Years ? `${product.returns.avgAnnual2Years.toFixed(2)}%` : 'לא זמין'}`,
      `   תשואה מצטברת 3 שנים אחרונות: ${product.returns?.year3 ? `${product.returns.year3.toFixed(2)}%` : 'לא זמין'}`,
      `   תשואה ממוצעת 3 שנים אחרונות: ${product.returns?.avgAnnual3Years ? `${product.returns.avgAnnual3Years.toFixed(2)}%` : 'לא זמין'}`,
      `   תשואה מצטברת 4 שנים אחרונות: ${product.returns?.year4 ? `${product.returns.year4.toFixed(2)}%` : 'לא זמין'}`,
      `   תשואה ממוצעת 4 שנים אחרונות: ${product.returns?.avgAnnual4Years ? `${product.returns.avgAnnual4Years.toFixed(2)}%` : 'לא זמין'}`,
      `   תשואה מצטברת 5 שנים אחרונות: ${product.returns?.year5 ? `${product.returns.year5.toFixed(2)}%` : 'לא זמין'}`,
      `   תשואה ממוצעת 5 שנים אחרונות: ${product.returns?.avgAnnual5Years ? `${product.returns.avgAnnual5Years.toFixed(2)}%` : 'לא זמין'}`,
      "",
      "🎯 חשיפות:",
      `   חשיפה למניות: ${stocksExp.toFixed(2)}%`,
      `   חשיפה לחו"ל: ${foreignExp.toFixed(2)}%`,
      `   חשיפה לארץ: ${domesticExp.toFixed(2)}%`,
      `   חשיפה למט"ח: ${currencyExp.toFixed(2)}%`,
      "",
      "⚖️ מדדי סיכון:",
      `   רמת סיכון: ${riskData.level} מתוך 5 (${riskData.name || 'לא זמין'})`,
      `   אלפא שנתית: ${product.performance?.alpha ? product.performance.alpha.toFixed(2) : 'לא זמין'}`,
      `   יחס שארפ: ${product.performance?.sharpeRatio ? product.performance.sharpeRatio.toFixed(2) : 'לא זמין'}`,
      "",
      "📅 תאריכים:",
      `   תאריך הקמה: ${product.inceptionDate || product.fundInfo?.inceptionDate || 'לא זמין'}`,
      `   תקופת דיווח אחרונה: ${product.reportPeriod ? formatReportPeriod(product.reportPeriod) : 'לא זמין'}`,
      "",
      "📱 יוצא מאתר גמל נט AI - המדריך החכם לעולם הפנסיה והחיסכון",
      `🔗 קישור למוצר: ${typeof window !== 'undefined' ? window.location.href : ''}`,
      `⏰ תאריך יצוא: ${new Date().toLocaleDateString('he-IL')} ${new Date().toLocaleTimeString('he-IL')}`,
      "",
 "⚠️ הבהרה:",
  "📊 המידע באתר גמל נט AI נועד להנגיש תובנות והשוואות, אך אינו מהווה ייעוץ פנסיוני, פיננסי או השקעות.",
  "📄✅ כל החלטה צריכה להיעשות תוך התאמה אישית ובליווי בעל רישיון מוסמך בלבד.",
  "⏳ תשואות עבר אינן מעידות בהכרח על ביצועים עתידיים, ואין לראות בנתונים באתר התחייבות או המלצה.",
  "🧠 אנו עושים מאמץ כנה בשילוב מערכות בינה מלאכותית מתקדמות לספק מידע מדויק, אך האחריות לשימוש בו ולפרשנותו היא בידי המשתמש בלבד.",
      "",
    ];

    return lines.join('\n');
  };

  const handleCopy = async () => {
    try {
      const exportText = generateExportText();
      await navigator.clipboard.writeText(exportText);
      setCopyStatus('copied');
      setTimeout(() => setCopyStatus(''), 2000);
    } catch (error) {
      console.error('Copy failed:', error);
      setCopyStatus('error');
      setTimeout(() => setCopyStatus(''), 2000);
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        const exportText = generateExportText();
        await navigator.share({
          title: `פרטי ${product?.name || 'הקופה'}`,
          text: exportText
        });
      } catch (error) {
        handleCopy(); // fallback להעתקה
      }
    } else {
      handleCopy(); // fallback להעתקה
    }
  };

  return (
    <div className="flex items-center gap-1">
      {/* כפתור שיתוף קומפקטי */}
      <button
        onClick={handleShare}
        className="flex items-center gap-1 px-2 py-1 text-xs font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors duration-200"
        title="שתף פרטי מסלול מלאים"
      >
        <Share2 className="w-3 h-3" />
        <span>שתף פרטי מסלול</span>
      </button>

      {/* כפתור העתקה קומפקטי */}
      <button
        onClick={handleCopy}
        className={`flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-md transition-colors duration-200 ${
          copyStatus === 'copied' 
            ? 'text-green-600 bg-green-50' 
            : copyStatus === 'error'
            ? 'text-red-600 bg-red-50'
            : 'text-gray-600 hover:text-gray-700 hover:bg-gray-50'
        }`}
        title="העתק את כל פרטי המסלול"
      >
        {copyStatus === 'copied' ? (
          <>
            <Check className="w-3 h-3" />
            <span>הועתק!</span>
          </>
        ) : (
          <>
            <Copy className="w-3 h-3" />
            <span>העתק</span>
          </>
        )}
      </button>
    </div>
  );
};

export default CompactExportButton;